var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCourseContent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M3.3,0.4H0.7C0.4,0.4,0.1,0.7,0.1,1c0,0,0,0,0,0v9c0,0.3,0.3,0.6,0.6,0.6c0,0,0,0,0,0h2.6     c0.3,0,0.6-0.3,0.6-0.6l0,0V1C3.8,0.7,3.6,0.4,3.3,0.4C3.3,0.4,3.3,0.4,3.3,0.4z M2.7,7.4H1.3V6.5h1.4V7.4z M2.7,5.9H1.3v-4h1.4     V5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M7.6,0.4H5.1C4.8,0.4,4.5,0.7,4.5,1l0,0v9c0,0.3,0.3,0.6,0.6,0.6l0,0h2.6     c0.3,0,0.6-0.3,0.6-0.6l0,0V1C8.2,0.7,8,0.4,7.6,0.4L7.6,0.4z M7.1,7.4H5.7V6.5h1.4V7.4z M7.1,5.9H5.7v-4h1.4V5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M14.9,9.2l-2.3-8.4c-0.1-0.3-0.4-0.5-0.7-0.4c0,0,0,0,0,0L9.5,1.1C9.2,1.2,9,1.5,9.1,1.8     c0,0,0,0,0,0l2.3,8.4c0.1,0.3,0.4,0.5,0.7,0.4l2.4-0.7C14.8,9.8,14.9,9.5,14.9,9.2C14.9,9.2,14.9,9.2,14.9,9.2z M11.4,6l-1-3.7     L11.7,2l1,3.7L11.4,6z M11.8,7.4l-0.2-0.8l1.3-0.4l0.2,0.8L11.8,7.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseContent);
export default __webpack_public_path__ + "static/media/icon-course-content.26d42d8f03ea12e625ffa90d9aa2113d.svg";
export { ForwardRef as ReactComponent };